import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { VoucherToolCall } from '../types';

interface VoucherCard extends LinkCardRecord {
  displayName: string | null;
  status: string;
}

interface VoucherCardsProps {
  toolCalls: VoucherToolCall[];
}

export function VoucherCards({ toolCalls }: VoucherCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.voucher}>
          {(voucher: VoucherCard) => (
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-truncate">{voucher.displayName}</span>
              <Badge appearance="muted" className="flex-shrink-0" variant="secondary">{voucher.status}</Badge>
            </div>
          )}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard index={index} key={index.path} label="vouchers" pageName="Vouchers" theme={CARD_THEMES.voucher} />
      ))}
    </>
  );
}
